<template>
  <Light class="light--red" :style="{ 'background-color': backgroundColor }"/>
</template>

<script>
  import Light from './Light';
  import {convertBrightness} from '../../utils';

  export default {
    name: 'RedLight',
    components: {
      Light
    },
    props: [
      'brightness'
    ],
    computed: {
      backgroundColor() {
        return `rgba(255, 0, 0, ${convertBrightness(this.brightness)})`;
      }
    }
  };
</script>

<style>
  .light--red {
    border-color: red;
  }
</style>
